import React, { useState, useContext, useEffect } from "react";
import classNames from "classnames/bind";
import { DownIcon, LeftIcon, Next, Previous } from "../../components/Icons/Icons";
import { Button, LoadComponent, Loading, Skeleton, Toast } from "../../components";
import ListLocation from "./ListLocation/ListLocation";
import useFetchLocation from "./useFetchLocation";
import Header from "./Header";
import Filter from "./Filter/Filter";
import SearchFail from "./SearchFaild/SearchFail";
import { CameraContext } from "../LiveCamera/LiveCamera";
import styles from "./Location.module.css";
import { useStoreContext } from "../../hooks/useStoreContext";
import axiosClient from "../../services/axiosClient";
import { useTranslation } from "react-i18next";
import { defaultCompanyFill, filterLocationDefault } from "../Administration/Camera/Filter/configFillter";

const cx = classNames.bind(styles);
const Location = () => {
  const {
    isApply,
    setIsApply,
    toggleReGetListCamera,
    setToggleReGetListCamera,
    isGroup,
    setIsGroup,
    setCurrentPage,
    setGroupCode,
    groupCode,
    oneThread,
    filterStatus,
    setFilterStatus
  } = useContext(CameraContext);

  const [filter, setFilter] = useState([]);
  const [value, setValue] = useState();
  const [listLocation, setListLocation] = useState([]);
  const [isFilter, setIsFilter] = useState(false);
  const [isSearchFail, setIsSearchFail] = useState(false);
  const [groupCam, setGroupCam] = useState();
  const [provinceCode, setProvinceCode] = useState();
  const [showSidebar, setShowSideBar] = useState(false);
  const { t } = useTranslation()

  // eslint-disable-next-line
  const [dataStore, dispatch] = useStoreContext();
  let reGetData = dataStore.toggleNotification;
  const handleShowWarehouse = (value) => {
    if (isGroup && oneThread) {
      setGroupCode(value);
      sessionStorage.setItem("groupCode", value)
    }
    if(isGroup){
    setCurrentPage(1)

    }
    const data = listLocation.map((item, index) => {
      if (item.code === value) {
        return {
          ...item,
          isShow: !item.isShow,
          icon: !item.isShow ? <DownIcon /> : <LeftIcon />,
        };
      }
      return {
        ...item,
        isShow: false,
        icon: <LeftIcon />,
      };
    });
    setListLocation(data);
  };
  const updateValue = (data) => {
    setValue(data);
  };
  const handleResetFilterStatus = (listFill) => {
    const filters = Object.entries(listFill)
    filters?.forEach((filter) => {
      listFill[filter[0]] = false;
    })
    return listFill;
  }
  const changeFilter = (data) => {
    setFilter(data);
    const checkStatus = data?.find((item) => item?.type === 'status')?.code === null;
    if (checkStatus) {
      setFilterStatus((pre) => {
        const fill = handleResetFilterStatus(pre);
        return fill;
      })
    }
  };
  const updateIsGroup = (data) => {
    setIsGroup(data);
  };
  const handleFilter = (data) => {
    setIsFilter(!isFilter);
    setFilter(data);
    const statusCam = data?.find(item => item?.type === 'status');
    if (statusCam && filterStatus && setFilterStatus) {
      const key = defaultCompanyFill.find(fill => fill?.value === statusCam?.code)?.key;
      setFilterStatus((pre) => {
        const reset = handleResetFilterStatus(pre);
        return {
          ...reset,
          [key]: !!key,
        };
      })

    }
  };
  // Change status apply
  const handleApply = (e) => {
    const data = dataStore.listCameraPriority;
    const putChangePriorityCamera = async (dataPut) => {
      try {
        const res = await axiosClient.put(
          "/camerainfo/put-set-status-camera-priority/",
          {
            list_cam: {
              data: dataPut,
            },
          }
        );
        Toast.open(t('location.updateSuccess'), "success");
        setToggleReGetListCamera(!toggleReGetListCamera);
        setIsApply(false);
        setCurrentPage(1);
        return res;
      } catch (error) {
        Toast.open(t('location.updateError'), "danger");
        throw new Error("We can't update list camera");
      }
    };
    if (data?.length > 0) {
      putChangePriorityCamera(data);
    } else {
      setIsApply(false);
    }
  };

  const groups = useFetchLocation(
    "warehouse/get-list-group-warehouse-by-username/",
    "warehouse/get-list-province-warehouse-by-username/",
    isGroup,
    { value, groupCam, provinceCode },
    // isApply,
    reGetData
  );

  useEffect(() => {
    if (filter) {
      filter.forEach((item) => {
        switch (item.type) {
          case "group":
            setGroupCam(item.name);
            break;
          case "province":
            setProvinceCode(item.code);
            break;
          default:
            return 0;
        }
      });
    }
  }, [filter]);

  React.useEffect(() => {
    let value;
    if (isGroup) {
      value = groups.data?.map((item) => {
        return {
          code: item.GROUP_CODE,
          name: item.GROUP_NAME,
          wareHouses: item.LIST_WAREHOUSE,
          icon: <LeftIcon />,
          isShow: false,
        };
      });
      if (value?.length > 0) {
        setIsSearchFail(false);
      } else {
        setIsSearchFail(true);
      }
    } else {
      value = groups.data?.map((item) => {
        return {
          code: item.PROVINCE_CODE,
          name: item.PROVINCE_NAME,
          wareHouses: item.LIST_WAREHOUSE,
          icon: <LeftIcon />,
          isShow: false,
        };
      });
      const check = groups.data?.every(
        (item) => item.LIST_WAREHOUSE?.length === 0
      );
      if (check) {
        setIsSearchFail(true);
      } else {
        setIsSearchFail(false);
      }
    }
    if (value && value?.length > 0 && value[0].code) {
      // sap xep dia chi
      const data = value?.sort((a, b) =>
        a?.name?.normalize('NFC').localeCompare(b?.name?.normalize('NFC'), 'vi', { sensitivity: 'accent' }));
      setListLocation(data);
    }
  }, [groups.data, isGroup]);

  // Lay lọc trạng thái ở màn stream khi lọc trajgn thái ở header xem stream
  useEffect(() => {
    if (filterStatus) {
      // nếu ở header chỉ lọc một trạng thái thì bên side bar lọc tương tụ, còn lớn hơn 1 thì side bar bỏ lọc trạng thái
      const listStatusActive = Object.entries(filterStatus).filter(status => status[1]);
      if (listStatusActive && listStatusActive?.length === 1) {
        const keyStatus = Object.entries(filterStatus).find(status => status[1])[0];
        const statusActive = defaultCompanyFill.find(fill => fill?.key === keyStatus);
        const defaultFill = filterLocationDefault?.map(fill => {
          if (fill?.type === 'status' && statusActive?.key) {
            return { ...fill, code: statusActive?.value, name: statusActive?.label }
          }
          return fill;
        })
        setFilter(defaultFill);
      } else {
        setFilter((pre) => {
          return pre?.map(it => {
            if (it?.type === 'status') {
              return {
                ...it,
                name: '',
                code: null
              }
            }
            return it;
          })
        });
      }
    }
  }, [filterStatus])

  return (
    <div className={cx("list", showSidebar && 'show')}>
      {isFilter ? (
        <Filter onFilter={handleFilter} isGroup={isGroup} />
      ) : (
        <>
          <div className={cx('header', showSidebar && 'show')}>
            <Header
              value={value}
              setValue={updateValue}
              filter={filter}
              setFilter={changeFilter}
              handleFilter={handleFilter}
              isGroup={isGroup}
              setIsGroup={updateIsGroup}
              type={"Stream"}
            />
          </div>
          {groups.isLoading ? (
            <>
              <Skeleton height={48} width={"100%"} />
              <Skeleton height={48} width={"100%"} />
            </>
          ) : (
            <div className={cx("list-location")}>
              {listLocation && listLocation?.length > 0 && !isSearchFail ? (
                listLocation.map((item, index) => {
                  if (item.wareHouses?.length >= 0) {
                    return (
                      <ListLocation
                        key={index}
                        indexLocation={index}
                        show={item.isShow}
                        onClick={handleShowWarehouse}
                        name={item.name}
                        wareHouses1={item.wareHouses}
                        icon={item.icon}
                        code={item.code}
                        value={value}
                        isGroup={isGroup}
                        filter={filter}
                        groupActive={groupCode}
                        setCurrentPage={setCurrentPage}
                      />
                    );
                  }
                  return <React.Fragment key={index}></React.Fragment>;
                })
              ) : (
                <SearchFail />
              )}
            </div>
          )}
          {isApply && (
            <div className={cx("apply")}>
              <Button
                title={t('location.accept')}
                className={cx("btn")}
                onClick={handleApply}
              />
            </div>
          )}
          <button className={cx('fixed-btn')} onClick={() => {
            setShowSideBar(!showSidebar)
          }}>
            {showSidebar ? <Previous /> : <Next />}
          </button>
        </>
      )}
    </div>
  );
};

export default Location;
